import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 11/16;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.903 4.928C14.397 1.988 11.415 0 8 0 4.585 0 1.602 1.99.097 4.928a.899.899 0 000 .81C1.603 8.679 4.585 10.668 8 10.668c3.415 0 6.398-1.99 7.903-4.928a.899.899 0 000-.811zM8 9.333a4 4 0 110-8 4 4 0 010 8zm0-6.666a2.648 2.648 0 00-.703.105A1.33 1.33 0 015.439 4.63 2.66 2.66 0 108 2.667z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconEye extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
